var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfile56(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16C2 13.7909 3.79086 12 6 12H50C52.2091 12 54 13.7909 54 16V40C54 42.2091 52.2091 44 50 44H6C3.79086 44 2 42.2091 2 40V16Z",
    fill: "#309FF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30C8 27.7909 9.79086 26 12 26H16C18.2091 26 20 27.7909 20 30V34C20 36.2091 18.2091 38 16 38H12C9.79086 38 8 36.2091 8 34V30Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29C24 27.8954 24.8954 27 26 27H42C43.1046 27 44 27.8954 44 29C44 30.1046 43.1046 31 42 31H26C24.8954 31 24 30.1046 24 29Z",
    fill: "#F5F5FF",
    fillOpacity: 0.68
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35C24 33.8954 24.8954 33 26 33H35C36.1046 33 37 33.8954 37 35C37 36.1046 36.1046 37 35 37H26C24.8954 37 24 36.1046 24 35Z",
    fill: "#F5F5FF",
    fillOpacity: 0.68
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile56);
export default __webpack_public_path__ + "static/media/profile_56.b490aca4.svg";
export { ForwardRef as ReactComponent };